import { render } from "./ClusterDetail.vue?vue&type=template&id=df1bcf08&scoped=true"
import script from "./ClusterDetail.vue?vue&type=script&lang=js"
export * from "./ClusterDetail.vue?vue&type=script&lang=js"

import "./ClusterDetail.vue?vue&type=style&index=0&id=df1bcf08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df1bcf08"]])

export default __exports__